/**
 * @file SeoFieldMark.tsx
 * @description Подпись поля «изменено 5 мин назад · Иван» и кнопка «Вернуть
 * прежнее» (phase19.16, партия Р3в, v0.19.64; SEO16, SB145). Кнопка
 * открывает журнал поля — последние 10 значений за 12 месяцев
 * (`SeoHistoryDialog`). Поле ещё не меняли — подписи и кнопки нет.
 */

import { History } from "lucide-react";

import { Button } from "../../ui/button";
import type { ShopSeoFieldKey, ShopSeoSettingsDto } from "../../../lib/api-site-seo";
import { changedText } from "../../../lib/site-seo/seo-fields";

interface Props {
  field: ShopSeoFieldKey;
  settings: ShopSeoSettingsDto;
  onHistory: (field: ShopSeoFieldKey) => void;
  readOnly?: boolean;
}

export function SeoFieldMark({ field, settings, onHistory, readOnly = false }: Props) {
  const text = changedText(settings.lastChanges[field]);
  if (!text) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-2">
      <span className="type-caption text-on-surface-variant">{text}</span>
      {readOnly ? null : (
        <Button variant="link" className="min-h-12 gap-1 lg:min-h-0" onClick={() => onHistory(field)}>
          <History aria-hidden className="size-4" />
          Вернуть прежнее
        </Button>
      )}
    </div>
  );
}
